import { useMutation } from "@apollo/client";

import {
  DeleteDeviceMutation,
  DeleteDeviceMutationVariables,
} from "../../../API";
import { useCustomerIdGuard } from "../../../common/hooks/useCustomerIdGuard";
import { DELETE_DEVICE } from "../../../common/operations/mutations";
import { successNotification } from "../../../common/variables/notification";
import { handleApolloError } from "../../../common/utils/handleApolloError";

export const useDeleteDevice = (deviceName: string) => {
  const selectedCustomerId = useCustomerIdGuard();

  const [deleteDeviceMutation, { data, loading }] = useMutation<
    DeleteDeviceMutation,
    DeleteDeviceMutationVariables
  >(DELETE_DEVICE);

  const deleteDevice = async (deviceId: string) => {
    return await deleteDeviceMutation({
      variables: {
        customerId: selectedCustomerId,
        deviceId: deviceId,
      },
      onCompleted: response => {
        if (response.deleteDevice) {
          successNotification(deviceName + " is deleted");
        }
      },
      onError: handleApolloError,
      update(cache) {
        const id = `Device:${deviceId}`;

        cache.evict({ id });

        cache.gc();
      },
    });
  };

  return { deleteDevice, data, loading };
};
